import {Component} from '@angular/core';

@Component({
    selector: 'app-inquiry',
    templateUrl: './inquiry-layout.component.html',
    styleUrls: ['./inquiry-layout.component.less']
})
export class InquiryLayoutComponent {
}
